module.exports = __webpack_public_path__ + "static/media/forensic_knight_logo.8fee4d32.png";